import { useContext } from "react";
import { AppContext } from "../App";
import { t } from "../i18n";
import { Icon } from "../components/Icon";

export const Header = ({ hours }) => {
	const { flow, route, data } = useContext(AppContext);

	return (
		<header
			className={
				"header" + (route === "selectDateTime" ? " finally" : "")
			}
		>
			<div className="header_wrapper">
				<div className="header_logos">
					<div className="header_ralarsa">
						<img
							className="header_img"
							src="resources/img/ralarsa.png"
							alt="Ralarsa"
						/>
					</div>

					<div className="separator"></div>

					{flow === "mapfre" ? (
						<div className="header_mapfre">
							<img
								className="header_img"
								src="resources/img/mapfre.svg"
								alt="Mapfre"
							/>
						</div>
					) : flow === "caser" ? (
						<div className="header_caser">
							<img
								className="header_img"
								src="resources/img/caser.png"
								alt="Caser"
							/>
						</div>
					) : flow === "allianz-direct" ? (
						<div className="header_allianz_direct">
							<img
								className="header_img"
								src="resources/img/allianz-direct.png"
								alt="Allianz Direct"
							/>
						</div>
					) : flow === "generali" ? (
						<div className="header_generali">
							<img
								className="header_img"
								src="resources/img/generali.png"
								alt="Generali"
							/>
						</div>
					) : flow === "mutua" ? (
						<div className="header_mutua">
							<img
								className="header_img"
								src="resources/img/mutua.svg"
								alt="Mutua Madrileña"
							/>
						</div>
					) : flow === "allianz" ? (
						<div className="header_allianz">
							<img
								className="header_img"
								src="resources/img/allianz.svg"
								alt="Allianz"
							/>
						</div>
					) : null}
				</div>

				{route === "selectDateTime" && (
					<div className="header_content">
						<h2 className="header_h2">
							<strong>{t("Elige una cita")}</strong>
						</h2>
						{/* {data.damageArea === "repair" ? (
							<p className="header_p">
								{t("En tu caso sólo necesitas una reparación.")}
							</p>
						) : (
							<p className="header_p">
								{t(
									"En tu caso es necesario una sustitución, trataremos de tener tu recambio listo en el taller elegido.",
								)}
							</p>
						)} */}
						<div className="header_time_info">
							<Icon name="timer" />
							<span>
								{data.damageArea === "repair"
									? t("Listo en tan solo 30 minutos")
									: data.damageGlass.includes("Lateral")
										? t(
												"Sustitución en 2 horas aprox.",
											)
										: t(
												"Sustitución en 2,5 horas aprox.",
											)}
							</span>
						</div>
					</div>
				)}

				{route === "loader" && (
					<div className="header_content">
						<img
							className="header_content_img"
							src="resources/img/confirm.png"
							alt="Reserva confirmada"
						/>
						<h2 className="header_h2 confirm_booking">
							{t("¡Gracias por tu reserva!")}
						</h2>
					</div>
				)}
			</div>
		</header>
	);
};
